<template>
<div class="champion-wrap">
    <h2 class="champion-label">ダートトラック全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2003</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>衛藤金治／オープン</li>
                    <li>衛藤金治／250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>谷口久輝／オープン</li>
                    <li>衛藤金治／250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2003年<span class="year-title__sub">平成15年</span></h2>
                <ul>
                    <li>衛藤金治／オープン</li>
                    <li>ケビン・アサートン／250cc</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['100']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>